import { get } from '../redux/api';
import { window } from '../globals';
import type { Permission } from '../../typings/permissions';

/**
 * Helper function that fetches the current user's permissions and updates the permissions in the window.user object.
 *
 * This is written in a very naive way - not using react-query or our AsyncValue - because of the weird way that this needs
 * to be executed. It should happen immediately and before other logic finishes.
 */
async function updateUserPermissions() {
  if (!window.user) {
    return;
  }

  try {
    const { data } = await get<Permission[]>('/api/users/me/permissions', true);

    if (data && window.user) {
      window.user.permissions = data;
    }
  } catch (_e) {
    // We don't really care if this errors since there's likely other, bigger problems with the API.
    // Any changes in permissions will be reflected in the next hard refresh anyway.
    // eslint-disable-next-line no-useless-return
    return;
  }
}

export default updateUserPermissions;
